module.exports = {
    list: ["Web application", "Admin application", "Bot application", "Desktop application", "Iot application", "Server application", "Mobile application"]
};
